module.exports = __webpack_public_path__ + "static/img/about_modle_1.8cad05d7.jpg";